import "../assets/Inliner.css";
import { defineComponent as L, useCssVars as W, unref as e, ref as x, computed as g, watchEffect as F, openBlock as $, createBlock as q, Transition as w, withCtx as S, withDirectives as y, createElementVNode as r, createVNode as c, vShow as k, createElementBlock as G, withModifiers as Y, createCommentVNode as E, normalizeClass as U, normalizeStyle as Z, TransitionGroup as ee, onUpdated as te, resolveDynamicComponent as oe, mergeProps as ae } from "vue";
import { D, f as se, b as B, a as V } from "./maps.DxC18PqJ.js";
import { i as ne } from "./XClose.vue_vue_type_style_index_0_lang.B6lW8SK8.js";
import { d as ie } from "./debounce.BDLEW31m.js";
import { u as O } from "./index.AJuLibkw.js";
import { d as J, e as Q, n as A, m as le, u as de } from "./useStore.CDG6wbfK.js";
import { a as H, m as K, t as re, r as ce } from "./useModal.CgbJKM9V.js";
import { _ as T } from "./Back.vue_vue_type_style_index_0_lang.D3HVPbBh.js";
import { _ as N } from "./Steps.vue_vue_type_style_index_0_lang.DnsnL9hF.js";
import { _ as R } from "./Modal.vue_vue_type_style_index_0_lang.CjTfpaRL.js";
import { _ as me, u as ue, a as pe, i as fe } from "./useImageStyles.DS4yuB--.js";
import { _ as he } from "./_plugin-vue_export-helper.CHgC5LLL.js";
import { u as ge, h as _e } from "./Text.vue_vue_type_style_index_0_lang.CqNxQPnN.js";
import { p as j } from "./parseToolData.CdJg7fgv.js";
function X(i) {
  return i === "px" ? J : Q;
}
function C(i) {
  const {
    format: p,
    top: a,
    right: t,
    bottom: m,
    left: o
  } = i.margin, s = X(p);
  return `${s(a)} ${s(t)} ${s(m)} ${s(o)}`;
}
function P(i) {
  const { width: p, widthFormat: a } = i;
  return `${X(a)(p)}`;
}
function I(i) {
  return {
    left: "start",
    center: "center",
    right: "end"
  }[i.alignment];
}
const ve = { class: "thn--tool-inline-container" }, be = { class: "thn--tool-inline-circular__content" }, xe = { class: "thn--tool-inline-circular__inliner" }, ye = /* @__PURE__ */ L({
  __name: "Circular",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {},
    embedded: {}
  },
  setup(i, { expose: p }) {
    W((h) => ({
      df302eec: e(I)(h.embedded[h.device]),
      "7961a078": e(Q)(u.value),
      e88ef6c2: e(J)(v.value),
      "50e57692": e(C)(h.embedded.desktop)
    }));
    const a = ie(re, 200, { leading: !0, trailing: !1 }), t = {
      [D.Desktop]: 530,
      [D.Mobile]: 340
    }, m = {
      horizontal: 0.1,
      vertical: 0.2
    }, o = i, s = A(), _ = x(!1), d = x(), { width: b } = O(d), u = g(() => o.embedded[o.device].width), v = g(() => t[o.device] * (u.value / 100)), f = g(() => b.value * (1 - 2 * m.vertical));
    F(() => {
      const h = b.value * m.horizontal;
      s == null || s.styles.addCssVariables(
        s.literals.device === D.Desktop ? {
          "--step-padding": `0px ${h}px 0px ${h}px`,
          "--module-margin-top": "20px",
          "--xclose-margin": "0px"
        } : {
          "--step-padding": `0px ${h}px 0px ${h}px`,
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
    });
    function n() {
      _.value = !1;
    }
    function M() {
      _.value = !0;
    }
    return p({
      show: n,
      hide: M
    }), (h, l) => ($(), q(w, {
      name: "fade",
      appear: ""
    }, {
      default: S(() => [
        y(r("div", ve, [
          r("div", {
            class: "thn--tool-inline-circular",
            ref_key: "rootDom",
            ref: d
          }, [
            r("div", be, [
              r("div", xe, [
                c(T, { class: "thn--tool-inline-circular__back" }),
                c(N, {
                  class: "thn--tool-inline-circular__steps",
                  steps: o.steps,
                  "has-extra-steps": o.hasSteps,
                  "max-height": f.value
                }, null, 8, ["steps", "has-extra-steps", "max-height"]),
                c(w, { name: "fade" }, {
                  default: S(() => [
                    y(c(R, { "terms-text": e(H) }, null, 8, ["terms-text"]), [
                      [k, e(K)]
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            c(w, { name: "fade" }, {
              default: S(() => [
                e(K) ? ($(), G("div", {
                  key: 0,
                  class: "thn--tool-xclose thn--tool-xclose--modal",
                  onMousedown: l[0] || (l[0] = Y(
                    //@ts-ignore
                    (...z) => e(a) && e(a)(...z),
                    ["left"]
                  )),
                  onClick: l[1] || (l[1] = //@ts-ignore
                  (...z) => e(a) && e(a)(...z))
                }, [
                  c(e(ne), { class: "thn--tool-xclose__svg" })
                ], 32)) : E("", !0)
              ]),
              _: 1
            })
          ], 512)
        ], 512), [
          [k, !_.value]
        ])
      ]),
      _: 1
    }));
  }
}), ke = {
  class: "thn--tool-custom-content",
  "data-add-module": !0
}, $e = /* @__PURE__ */ L({
  __name: "CustomImage",
  props: {
    language: {},
    device: {},
    steps: {},
    layout: {},
    embedded: {}
  },
  setup(i, { expose: p }) {
    W((n) => ({
      25374623: e(P)(n.embedded.desktop),
      "44b94ec6": e(C)(n.embedded.desktop),
      "82c8f1fc": e(I)(n.embedded.desktop),
      "6dd8a49c": e(I)(n.embedded.mobile),
      "6739f31e": e(P)(n.embedded.mobile),
      "9d648692": e(C)(n.embedded.mobile)
    }));
    const a = i, t = A(), m = x(), o = x(!1), { width: s, height: _ } = O(m), d = g(() => a.steps[se.Main][0]), b = g(() => {
      if (s.value) {
        const n = (t == null ? void 0 : t.literals.device) === D.Mobile ? 0.9 : 0.8;
        return s.value * n;
      }
      return 300;
    }), u = g(() => {
      if (_.value) {
        const n = (t == null ? void 0 : t.literals.device) === D.Mobile ? 0.9 : 0.8;
        return _.value * n;
      }
      return 300;
    });
    function v() {
      o.value = !1;
    }
    function f() {
      o.value = !0;
    }
    return p({
      show: v,
      hide: f
    }), (n, M) => ($(), q(w, {
      name: "fade",
      appear: ""
    }, {
      default: S(() => [
        y(r("div", {
          class: "thn--tool-inline-custom-image",
          ref_key: "rootDom",
          ref: m
        }, [
          r("div", ke, [
            c(me, {
              class: "thn--tool-inline-custom-image__image",
              "module-props": d.value,
              "max-width": b.value,
              "max-height": u.value
            }, null, 8, ["module-props", "max-width", "max-height"])
          ])
        ], 512), [
          [k, !o.value]
        ])
      ]),
      _: 1
    }));
  }
}), Se = /* @__PURE__ */ he($e, [["__scopeId", "data-v-3b92e182"]]), we = { class: "thn--tool-inline-square__inliner" }, De = /* @__PURE__ */ L({
  __name: "Square",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {},
    embedded: {}
  },
  setup(i, { expose: p }) {
    W((d) => ({
      "327edbe1": e(P)(d.embedded.desktop),
      "794e7a9f": e(C)(d.embedded.desktop),
      "0e860dc0": e(I)(d.embedded.desktop),
      "267e5734": e(I)(d.embedded.mobile),
      "55da7e1a": e(P)(d.embedded.mobile),
      "82d55b16": e(C)(d.embedded.mobile)
    }));
    const a = i, t = A(), m = x(!1), o = x();
    F(() => {
      t == null || t.styles.addCssVariables(
        t.literals.device === D.Desktop ? {
          "--step-padding": "32px",
          "--module-margin-top": "16px",
          "--xclose-margin": "10px"
        } : {
          "--step-padding": "25px",
          "--module-margin-top": "15px",
          "--xclose-margin": "5px"
        }
      );
    });
    function s() {
      m.value = !1;
    }
    function _() {
      m.value = !0;
    }
    return p({
      show: s,
      hide: _
    }), (d, b) => ($(), q(w, {
      name: "fade",
      appear: ""
    }, {
      default: S(() => [
        y(r("div", {
          class: "thn--tool-inline-square",
          ref_key: "rootDom",
          ref: o
        }, [
          r("div", we, [
            c(T, { class: "thn--tool-inline-square__back" }),
            c(N, {
              class: "thn--tool-inline-square__steps",
              steps: a.steps,
              "has-extra-steps": a.hasSteps,
              "tool-kind": e(B).Inliner
            }, null, 8, ["steps", "has-extra-steps", "tool-kind"]),
            c(w, { name: "fade" }, {
              default: S(() => [
                y(c(R, { "terms-text": e(H) }, null, 8, ["terms-text"]), [
                  [k, e(K)]
                ])
              ]),
              _: 1
            })
          ])
        ], 512), [
          [k, !m.value]
        ])
      ]),
      _: 1
    }));
  }
}), qe = { class: "thn--tool-inline-square-image__inliner" }, Ce = ["data-loaded"], Ie = { class: "image__wrapper" }, Me = ["src", "alt"], Pe = { class: "w-full h-full bg-base-300 flex items-center justify-center" }, Ve = /* @__PURE__ */ L({
  __name: "SquareImage",
  props: {
    language: {},
    device: {},
    steps: {},
    hasSteps: {},
    layout: {},
    embedded: {}
  },
  setup(i, { expose: p }) {
    W((l) => ({
      fd8ddb74: e(I)(l.embedded.desktop),
      ac75d932: e(P)(l.embedded.desktop),
      "2a61984e": e(C)(l.embedded.desktop),
      "3ab5a9ee": e(I)(l.embedded.mobile),
      "3c0480ad": e(P)(l.embedded.mobile),
      "35db89fb": e(C)(l.embedded.mobile)
    }));
    const a = A(), t = i, m = x(), o = x(!1), s = x(!1), _ = g(() => t.layout), d = g(() => t.device), { imageUrl: b, imageAlt: u } = ue(_, d), v = g(() => {
      var l;
      return t.device === D.Mobile ? "top" : ((l = t.layout) == null ? void 0 : l.imagePosition) ?? "left";
    }), { imageStyles: f } = pe(
      g(() => t.layout),
      g(() => t.device),
      v
    );
    F(() => {
      a == null || a.styles.addCssVariables(
        a.literals.device === D.Desktop ? {
          "--step-padding": "28px",
          "--module-margin-top": "16px",
          "--xclose-margin": "10px",
          "--square-image-display": "grid"
        } : {
          "--step-padding": "20px",
          "--module-margin-top": "15px",
          "--xclose-margin": "5px",
          "--square-image-display": "flex"
        }
      ), b.value || (o.value = !1);
    });
    function n() {
      s.value = !1;
    }
    function M() {
      s.value = !0;
    }
    function h() {
      o.value = !0;
    }
    return p({
      show: n,
      hide: M
    }), (l, z) => ($(), q(w, {
      name: "fade",
      appear: ""
    }, {
      default: S(() => [
        y(r("div", {
          class: "thn--tool-inline-square-image",
          ref_key: "rootDom",
          ref: m
        }, [
          r("div", qe, [
            e(f) ? ($(), q(T, {
              key: 0,
              class: "thn--tool-inline-square-image__back"
            })) : E("", !0),
            r("div", {
              class: U([
                "thn--tool-inline-square-image__inliner__wrapper",
                v.value
              ])
            }, [
              r("div", {
                class: "thn--tool-inline-square-image__image",
                "data-loaded": o.value,
                style: Z(e(f))
              }, [
                c(ee, { name: "fade" }, {
                  default: S(() => [
                    y(r("div", Ie, [
                      r("img", {
                        src: e(b),
                        onLoad: h,
                        alt: e(u)
                      }, null, 40, Me)
                    ], 512), [
                      [k, o.value]
                    ]),
                    y(r("div", Pe, [
                      c(e(fe), { class: "img-icon" })
                    ], 512), [
                      [k, !o.value]
                    ])
                  ]),
                  _: 1
                })
              ], 12, Ce),
              r("div", {
                class: U(["thn--tool-inline-square-image__content", [{ relative: o.value }]])
              }, [
                e(f) ? E("", !0) : ($(), q(T, {
                  key: 0,
                  class: "thn--tool-inline-square-image__back"
                })),
                c(N, {
                  class: "thn--tool-inline-square-image__steps",
                  steps: t.steps,
                  "has-extra-steps": t.hasSteps,
                  "layout-kind": e(V).SquareImage,
                  "tool-kind": e(B).Inliner
                }, null, 8, ["steps", "has-extra-steps", "layout-kind", "tool-kind"])
              ], 2),
              c(w, { name: "fade" }, {
                default: S(() => [
                  y(c(R, { "terms-text": e(H) }, null, 8, ["terms-text"]), [
                    [k, e(K)]
                  ])
                ]),
                _: 1
              })
            ], 2)
          ])
        ], 512), [
          [k, !s.value]
        ])
      ]),
      _: 1
    }));
  }
}), Le = ["data-builder-mode", "data-device", "data-content-alignment", "data-layout-kind", "data-text-direction"], Je = /* @__PURE__ */ L({
  __name: "Inliner",
  props: {
    tool: {},
    context: {}
  },
  emits: [
    "hidden"
  ],
  setup(i, { emit: p }) {
    const a = {
      [V.Circular]: ye,
      [V.CustomImage]: Se,
      [V.Square]: De,
      [V.SquareImage]: Ve
    }, t = i, m = p, o = le(j({
      ...t,
      toolKind: B.Inliner
    })), s = x(), _ = g(() => {
      const {
        language: u,
        deviceViewport: v
      } = t.context, {
        content: {
          modules: f
        },
        settings: {
          layout: n,
          embedded: M
        }
      } = t.tool, h = ge(f), l = _e(f);
      return {
        language: u,
        device: v,
        steps: h,
        hasSteps: l,
        layout: n,
        embedded: M
      };
    }), d = g(() => {
      var v;
      if (!t.tool.settings.layout)
        return null;
      const u = (v = t.tool.settings.layout) == null ? void 0 : v.type;
      return a[u];
    });
    te(() => {
      de(j({
        ...t,
        toolKind: B.Layer
      }));
    });
    function b() {
      o.handlers.reset(), ce(), m("hidden");
    }
    return (u, v) => {
      var f, n;
      return $(), G("div", {
        class: "thn--tool thn--tool-inliner",
        "data-builder-mode": u.context.builderMode,
        "data-device": u.context.deviceViewport,
        "data-content-alignment": (f = u.tool.settings.layout) == null ? void 0 : f.contentAlignment,
        "data-layout-kind": (n = u.tool.settings.layout) == null ? void 0 : n.type,
        "data-text-direction": e(o).rtl ? "rtl" : "ltr"
      }, [
        ($(), q(oe(d.value), ae({
          ref_key: "componentRef",
          ref: s
        }, _.value, { onAfterLeave: b }), null, 16))
      ], 8, Le);
    };
  }
});
export {
  Je as _,
  P as a,
  I as b,
  C as c
};
//# sourceMappingURL=Inliner.vue_vue_type_style_index_0_lang.BR3Id-_j.js.map
